<template>
  <span>
    <a class="btn btn-link" @click="toggleStudentModal(true)"><i class="fa fa-copy"/> Copy to another folder</a>
    <modal
      v-model="showStudentModal"
      title="Copy Goal To Another Folder"
      @hide="choseStudent(null)">
      <transition name="fade">
        <ChooseStudentForm
          v-if="showStudentModal && !errorMessage"
          :all-students="allStudents"
          :recent-students="filteredRecentStudents"
          @selectedStudent:existing="choseStudent"
          @selectedStudent:new="choseStudent"
        />
      </transition>
      <alert type="danger" v-if="!!errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
        <p>Please close this modal and try again. Contact support if issues persist.</p>
      </alert>
      <div class="btn-toolbar" slot="footer">
        <button
          class="btn btn-success btn-lg"
          :disabled="!studentName || copying || !!errorMessage"
          @click="copyGoalForAnotherStudent()">
          <template v-if="!copying">Copy to <span class="fs-block">{{ studentName || 'a folder' }}</span></template>
          <template v-if="copying">Copying...</template>
        </button>
        <button class="btn btn-link btn-lg" @click="toggleStudentModal(false)">Cancel</button>
      </div>
    </modal>
  </span>
</template>

<script>
import { addGoalForStudent } from '@/api/library'
import { libraryQuotasMixin } from '@/components/library/library_quotas_mixin'
import ChooseStudentForm from '@/components/library/ChooseStudentForm'
import { mapGetters, mapState, mapActions } from 'vuex'
import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  name: 'CopyGoalForAnotherStudentButton',
  mixins: [libraryQuotasMixin],
  components: {
    ChooseStudentForm
  },
  data() {
    return {
      student: null,
      copying: false,
      showStudentModal: false,
      errorMessage: ''
    }
  },
  props: {
    sourceGoalUuid: {
      type: String,
      required: true
    },
    adaptedGoals: {
      type: Array,
      default() {
        return []
      }
    },
    gradeLevelGoal: {
      type: String,
      default() {
        return ''
      }
    },
    personalized: {
      type: Boolean,
      required: true
    },
    anchorPage: {
      type: Boolean,
      required: true
    },
    originalStudent: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters('contentProfile', ['profileId']),
    ...mapGetters('customgoal', ['levelToAttributeNames']),
    ...mapState('library', ['students', 'recentStudents']),
    ...mapState('user', { userUuid: state => state.user.uuid }),
    studentName() {
      return (this.student && this.student.name) || ''
    },
    allStudents() {
      return this.students.filter(student => {
        return student.uuid !== this.originalStudent.uuid
      })
    },
    filteredRecentStudents() {
      return this.recentStudents.filter(student => {
        return student.uuid !== this.originalStudent.uuid
      })
    }
  },
  methods: {
    ...mapActions('library', ['fetchStudents', 'fetchRecentStudents']),
    choseStudent(student) {
      this.student = student
    },
    toggleStudentModal(flag) {
      this.showStudentModal = flag
      if (flag) {
        this.errorMessage = ''
      }
    },
    copyGoalForAnotherStudent() {
      let contentType = this.anchorPage ? CONTENT_TYPES.SAVED_SUPER_PAGE : CONTENT_TYPES.SAVED_GOAL
      if (
        this.student &&
        this.student.uuid &&
        this.maxContentReachedForStudent(contentType, this.student.uuid)
      ) {
        this.errorMessage = this.maxContentTypeErrorMessage(contentType)
        return
      }
      this.copying = true
      var payload = {
        goal_uuid: this.sourceGoalUuid,
        user_uuid: this.userUuid,
        content_profile_id: this.profileId,
        grade_level_goal: this.gradeLevelGoal,
        save_by_copy: true,
        personalized: this.personalized
      }
      if (!this.anchorPage) {
        this.adaptedGoals.forEach(goal => {
          payload[this.levelToAttributeNames[goal.level]] = goal.text
        })
      } else {
        payload.objectives = this.adaptedGoals
      }
      addGoalForStudent(this.student, payload)
        .then(resp => {
          this.showStudentModal = false
          this.copying = false
          this.$sendEvent('Copied Library Content For Student', {
            content_type: contentType,
            copied_for_uuid: this.student.uuid
          })
          if (this.anchorPage) {
            this.$router.push({ name: 'SavedAnchorPage', params: { uuid: resp.uuid } })
          } else {
            this.$router.push({ name: 'SavedGoalContentPage', params: { uuid: resp.uuid } })
          }
        })
        .catch(err => {
          this.copying = false
          console.error(err)
          this.errorMessage = err.message
        })
    },
    loadUserStudents() {
      this.fetchRecentStudents(this.userUuid)
        .then(() => {
          return this.fetchStudents(this.userUuid)
        })
        .catch(err => {
          console.error(`Error loading students in SaveToLibraryButton: ${err}`)
        })
    }
  },
  mounted() {
    if (this.userUuid) {
      this.loadUserStudents()
    }
  }
}
</script>

<style lang="less">
</style>
